import { useRef, useEffect, useState } from "react";
import { motion, useInView } from "framer-motion";

const stats = [
  { value: 500, suffix: "+", label: "Vulnerabilidades neutralizadas" },
  { value: 24, suffix: "/7", label: "Vigilancia del SOC" },
  { value: 99.9, suffix: "%", label: "Disponibilidad garantizada" },
  { value: 0, suffix: "", label: "Brechas en clientes activos" },
];

const Counter = ({ value, suffix }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true });
  const [n, setN] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const isFloat = !Number.isInteger(value);
    let start = null;
    const dur = 1400;
    const step = (t) => {
      if (!start) start = t;
      const p = Math.min((t - start) / dur, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setN(isFloat ? +(value * eased).toFixed(1) : Math.floor(value * eased));
      if (p < 1) requestAnimationFrame(step);
      else setN(value);
    };
    requestAnimationFrame(step);
  }, [inView, value]);

  return (
    <span ref={ref}>
      {n}
      <span className="text-cyber-cyan">{suffix}</span>
    </span>
  );
};

export const Stats = () => (
  <section className="relative border-y border-white/10 bg-white/[0.02]" data-testid="stats">
    <div className="mx-auto grid max-w-7xl grid-cols-2 gap-px px-5 md:grid-cols-4 md:px-10">
      {stats.map((s, i) => (
        <motion.div
          key={s.label}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: i * 0.1 }}
          className="flex flex-col gap-2 py-14 md:items-start"
          data-testid={`stat-${i}`}
        >
          <span className="font-head text-4xl font-black tracking-tighter text-white md:text-6xl">
            <Counter value={s.value} suffix={s.suffix} />
          </span>
          <span className="font-mono-tech text-[11px] uppercase tracking-[0.15em] text-white/50">
            {s.label}
          </span>
        </motion.div>
      ))}
    </div>
  </section>
);
